import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HeroSection = () => {
  const slides = [
    {
      title: "Trusted Quality. Right Price.",
      subtitle: "Proven Performance",
      description: "Engineered for Smooth, Reliable Handling",
      backgroundImage: "/images/hero-background.jpg",
      buttons: [
        { text: "View Products", link: "/products", primary: true },
        { text: "Contact Us", link: "/contact", primary: false }
      ]
    },
    {
      title: "Professional Material Handling",
      subtitle: "Equipment Solutions",
      description: "Built for Industrial Excellence",
      backgroundImage: "/images/hero-background2.jpeg",
      buttons: [
        { text: "Our Solutions", link: "/products", primary: true },
        { text: "Learn More", link: "/about", primary: false }
      ]
    },
    {
      title: "Safety First.",
      subtitle: "Quality Always.",
      description: "Your Trusted Partner in Material Handling",
      backgroundImage: "/images/hero-background3.jpeg",
      buttons: [
        { text: "Get Started", link: "/products", primary: true },
        { text: "Get Quote", link: "/contact", primary: false }
      ]
    }
  ];

  return (
    <section className="relative overflow-hidden hero-section">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative text-white py-32">
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url("${slide.backgroundImage}")`
                }}
              ></div>

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-catalina-blue/40 to-san-marino/40"></div>

              {/* Pattern Overlay */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                  backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
                }}></div>
              </div>

              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center">
                  <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-fade-in">
                    {slide.title}
                  </h1>
                  <h2 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in">
                    {slide.subtitle}
                  </h2>
                  <p className="text-xl md:text-2xl mb-8 text-gray-200 animate-fade-in">
                    {slide.description}
                  </p>
                  
                  {/* Action Buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    {slide.buttons.map((button, btnIndex) => (
                      <Link
                        key={btnIndex}
                        to={button.link}
                        className={`px-8 py-3 rounded-lg text-lg font-semibold transition duration-300 shadow-lg hover:shadow-xl ${
                          button.primary
                            ? 'bg-white text-catalina-blue hover:bg-gray-100'
                            : 'bg-transparent text-white border-2 border-white hover:bg-white hover:text-catalina-blue'
                        }`}
                      >
                        {button.text}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HeroSection;